<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";

#app {
  //id为“app”的dom的class
  width: 100%;
  height: 100%;
}
</style>
